// Function not being consumed anywhere in web-app

import { nanoid } from "nanoid";

export const generateRandomId = () => {
  return nanoid(10);
};
